export { default } from './BaseEmptyState';
